// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__ra12g","Big":"Button_Big__2wMal","UltraBig":"Button_UltraBig__UU3Lp","Middle":"Button_Middle__1CSJM","Inverted":"Button_Inverted__3IF-i"};